import React from 'react';
import { Heart, Download } from 'lucide-react';
import { Track } from '../types';
import { tg } from '../services/telegram';
import { userStore } from '../services/userStore';
import { CassetteReelIcon } from './icons/HardwareIcons';

interface TrackCardProps {
  track: Track;
  index: number;
  isActive: boolean;
  isPlaying: boolean;
  isFavorite?: boolean;
  onSelect: () => void;
  onToggleFavorite?: (track: Track) => void;
  onSendFlacToBot?: (track: Track) => void;
}

export const TrackCard: React.FC<TrackCardProps> = ({
  track,
  index,
  isActive,
  isPlaying,
  isFavorite,
  onSelect,
  onToggleFavorite,
  onSendFlacToBot,
}) => {
  const trackNumber = String(index + 1).padStart(2, '0');
  const isFav = isFavorite !== undefined ? isFavorite : userStore.isFavorite(track.id);
  const qualityBadge = track.bitDepth === '24-bit' ? '24-бит' : 'FLAC';

  const handleLikeClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    tg.haptic('light');
    if (onToggleFavorite) {
      onToggleFavorite(track);
    } else {
      userStore.toggleFavorite(track);
    }
  };

  const handleFlacClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    tg.haptic('medium');
    if (onSendFlacToBot) {
      onSendFlacToBot(track);
    }
  };

  return (
    <div
      className={`cassette-spine-item ${isActive ? 'active' : ''}`}
      onClick={() => {
        tg.haptic('medium');
        onSelect();
      }}
    >
      <div className="spine-left">
        <span className="spine-code">{trackNumber}</span>
        <img
          src={track.coverUrl}
          alt=""
          className="spine-thumb"
          loading="lazy"
        />
        <div className="spine-meta-wrap">
          <div className="spine-title">{track.title}</div>
          <div className="spine-sub">
            {track.artist} • {track.album}
          </div>
        </div>
      </div>

      <div className="spine-right">
        {isActive && (
          <span className={`spine-reel-indicator ${isPlaying ? 'spinning' : ''}`}>
            <CassetteReelIcon size={13} color="var(--amber)" />
          </span>
        )}
        <span className="spine-duration">{track.durationFormatted}</span>
        <span className="spine-spec">{qualityBadge}</span>
        {onSendFlacToBot && (
          <button
            type="button"
            className="spine-flac-btn"
            onClick={handleFlacClick}
            title="Отправить FLAC в чат Telegram"
            aria-label="Отправить FLAC в бота"
          >
            <Download size={12} />
          </button>
        )}
        <button
          type="button"
          className={`spine-like-btn ${isFav ? 'liked' : ''}`}
          onClick={handleLikeClick}
          aria-label={isFav ? 'Удалить из избранного' : 'Добавить в избранное'}
        >
          <Heart
            size={13}
            fill={isFav ? 'var(--amber)' : 'none'}
            color={isFav ? 'var(--amber)' : 'var(--champagne-dim)'}
          />
        </button>
      </div>
    </div>
  );
};

